export enum SortOrder {

  ASCENDING, DESCENDING, UNSORTED

}
